export const ru = {
    clicks: 'Всего кликов',
    'compact-title': 'Итого',
    conversion: 'Конверсии',
    cost: 'Общий расход',
    costPerClick: 'Цена за клик',
    cpa: 'CPA',
    cpc: 'CPC',
    ctr: 'средний CTR',
    profit: 'Общий доход',
    roi: 'ROI',
    shows: 'Всего показов'
};
